import styled from 'styled-components'

export const StyledForm = styled.form`
  padding: 24px 0;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
`